import React from "react"
import GridToggle from "app/static/frontend/components/GridToggle"
import { Row, Col } from "react-bootstrap"

/**
 * Grid Toggle component for Sheet search triggers with boolean fields.
 * See searchTriggerForColumnType for specific columnTypes that require this component.
 * Optionally provide the labels for "Yes/No" by adding column fields columnSearchTrueLabel
 * and columnSearchFalseLabel.
 *
 * @name ColumnSearchGridToggle
 * @function
 * @param {boolean} value - current active value of the grid toggle.
 * @param {Object} column - column associated to this trigger, optionally includes the fields
 *                          columnSearchTrueLabel and columnSearchFalseLabel if labels are unique.
 *
 */
export const ColumnSearchGridToggle = ({ value, search, column, ...props }) => {
    let trueLabel = (column && column.columnSearchTrueLabel) || "Yes"
    let falseLabel = (column && column.columnSearchFalseLabel) || "No"

    return (
        <Row>
            <Col md={12}>
                <GridToggle
                    bsColWidth={12}
                    options={[{ value: true, label: trueLabel }, { value: false, label: falseLabel }]}
                    onChange={search}
                    value={value}
                />
            </Col>
        </Row>
    )
}

export default ColumnSearchGridToggle
